module.exports = __webpack_public_path__ + "img/skin-thickness-image.e2836c5e.svg";